import { render } from "./LinkCustomersToCustomerDepotDiscountGroup.html?vue&type=template&id=4c82f6f5&scoped=true"
import script from "./LinkCustomersToCustomerDepotDiscountGroup.js?vue&type=script&lang=js"
export * from "./LinkCustomersToCustomerDepotDiscountGroup.js?vue&type=script&lang=js"

import "./LinkCustomersToCustomerDepotDiscountGroup.css?vue&type=style&index=0&id=4c82f6f5&scoped=true&lang=css"

import exportComponent from "/Users/blakegilbert/Documents/Projects/ShipTech/st-web-petro-network-admin-portal/src/ST.PetroNetworkAdmin.Web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c82f6f5"]])

export default __exports__